import axios from 'axios'

const url = process.env.REACT_APP_contactURL || process.env.REACT_APP_local

export const fetchContacts = () => axios.get(url)
export const createContact = (createContact) => axios.post(url, createContact)